import {setUnsavedGuard, clearUnsavedGuard} from './unsavedChangesGuard';

export default class UnsavedChangesController {
  constructor({isDirty, onBlocked, getNavigation}) {
    this.isDirty = isDirty;
    this.onBlocked = onBlocked;
    this.getNavigation = getNavigation;
    this.pendingNavigation = null;
    this.beforeUnloadBound = false;
    this.removeBeforeRemove = null;
    this.bypassNextNavigation = false;
    this.block = this.block.bind(this);
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
  }

  allowNextNavigation() {
    this.bypassNextNavigation = true;
  }

  hasPendingNavigation() {
    return this.pendingNavigation !== null;
  }

  attach() {
    const navigation = this.getNavigation();
    if (!navigation || typeof navigation.addListener !== 'function') return;
    this.removeBeforeRemove = navigation.addListener('beforeRemove', event => {
      if (this.bypassNextNavigation) {
        this.bypassNextNavigation = false;
        return;
      }
      if (!this.isDirty()) return;
      event.preventDefault();
      this.block(() => navigation.dispatch(event.data.action));
    });
  }

  detach() {
    if (this.removeBeforeRemove) {
      this.removeBeforeRemove();
      this.removeBeforeRemove = null;
    }
    this.release();
  }

  sync() {
    if (this.isDirty()) {
      setUnsavedGuard(this.block);
      if (typeof window !== 'undefined' && !this.beforeUnloadBound) {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        this.beforeUnloadBound = true;
      }
    } else {
      this.release();
    }
  }

  release() {
    clearUnsavedGuard(this.block);
    if (typeof window !== 'undefined' && this.beforeUnloadBound) {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      this.beforeUnloadBound = false;
    }
  }

  block(performNavigation) {
    this.pendingNavigation = performNavigation;
    this.onBlocked();
  }

  handleBeforeUnload(event) {
    if (!this.isDirty()) return undefined;
    event.preventDefault();
    event.returnValue = '';
    return '';
  }

  resume() {
    const performNavigation = this.pendingNavigation;
    this.pendingNavigation = null;
    this.release();
    if (performNavigation) {
      performNavigation();
    }
  }

  cancel() {
    this.pendingNavigation = null;
  }
}
